<template>
    <div>
        
        <div class="container">
            <Cabecera></Cabecera>
             <b-breadcrumb>
    <b-breadcrumb-item href="#"><router-link to="/">Inicio</router-link></b-breadcrumb-item>
    <b-breadcrumb-item href="#"><router-link to="/Registro">Registro </router-link></b-breadcrumb-item>
   
  </b-breadcrumb>
<div class="row">
    <div class="col s12 m12 l12">
      <div class="card">
        <div class="card-content  black-text">
          <span class="card-title">Registro</span>
          <form id="formRegistro" autocomplete="off" @submit.prevent="registro" enctype="multipart/form-data">
            <input type="text" name="usuario" placeholder="Nombre de usuario" required pattern="[A-Za-z]{5,30}">
            <input type="password" v-model="pass" name="pass" placeholder="Password" required pattern="[A-Za-z0-9]{8,15}">
            <input type="password" v-model="passC" name="pass" placeholder="Confirmar password" required pattern="[A-Za-z0-9]{8,15}">
            <input type="email" v-model='correo' name="email" placeholder="Correo Electrónico" @blur="validarCorreo" required>
            <div class="file-field input-field">
                <div class="btn">
                <span>Imagen de perfil</span>
                <input type="file" name="foto">
                </div>
                <div class="file-path-wrapper">
                <input class="file-path validate" type="text">
                </div>
            </div>
            
            <input type="submit" value="Registrar" :class="boton">
            </form>
        </div>
        <div class="card-action">
          
          <router-link to="/">Iniciar Sesión</router-link>
        </div>
      </div>
    </div>
  </div>

</div> 
    </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Cabecera from './Cabecera'
export default {
    name:'Registro',
    data(){
        return{
            pass:'',
        passC:'',
        respuesta:'',
        correo:'',
        boton:'btn blue disabled',
        }
        
    },
    components:{
    Cabecera
  },
  
    methods:{
        registro(){
            if (this.pass == this.passC) {
                if(this.boton == 'btn blue'){
                const form=document.getElementById('formRegistro')
                axios.post('https://micomidasegura.mx/comidaSegura/apiveg/loginRegistro/registro.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                   
                })
                axios.post('https://micomidasegura.mx/comidaSegura/api/loginRegistro/registro.php',new FormData(form))
                .then(res=>{
                    this.respuesta = res.data
                    swal({
                    title:'Usuario registrado con éxito',
                    icon: 'success'})  
            
            
                    this.direccionamiento()
                })
            }
            else{
              swal({
                    title:'Verifica el correo electrónico',
                    icon: 'error'})  
            }
            }
             else {
                swal({
                    title:'Los password no coinciden',
                    icon: 'error'})
            }
        },
        direccionamiento(){
            if (this.respuesta=='success') {
                this.$router.push('/')
            } else {
                swal({
                    title:'No se pudo registrar'+this.respuesta,
                    icon: 'error'})  
            }
        },
        validarCorreo(){
            if (this.validEmail(this.correo)) {
                const formData = new FormData()
                formData.append('correo',this.correo)
               /* EN caso de querer mandar más de un dato se repite varias veces y se cambia el nombre y la variable
                FormData.append('correo',this.correo)
                FormData.append('correo',this.correo)*/
                //axios.post('httpss://proyectocdnywebpack.000webhostapp.com/snippetWebpack/api/loginRegistro/validarEmail.php',formData)
                axios.post('https://micomidasegura.mx/comidaSegura/api/loginRegistro/validarEmail.php',formData)
                    .then(res=>{
                        this.respuesta = res.data
                        if (res.data =='success') {
                            this.boton = 'btn blue'
                        } else {
                            this.boton = 'btn blue disabled'
                            swal({
                    title:'El correo electrónico ya existe',
                    icon: 'error'}) 
                        }
                    }) 
            } else {
                swal('Escribe el correo de forma correcta')
            }
        },
        ////<h5>RES: {{respuesta}}</h5>
        validEmail: function (email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
    },
    
}
</script>


// WEBPACK FOOTER //
// src/components/Registro.vue